/* eslint-disable */
// WARNING: This file is generated during build from Gen 2 outputs and amplify/runtime-config.json.

const awsmobile = {
  "aws_project_region": "eu-west-2",
  "aws_cognito_identity_pool_id": "eu-west-2:6c5e6c39-5600-4f70-a066-1e24795a0bed",
  "aws_cognito_region": "eu-west-2",
  "aws_user_pools_id": "eu-west-2_WjLPmRJJ8",
  "aws_user_pools_web_client_id": "341tvg51idi7j5naa0v11rbau",
  "oauth": {},
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "GIVEN_NAME",
    "FAMILY_NAME",
    "EMAIL",
    "PHONE_NUMBER"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS"
    ]
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "meadocumentsbucket104004-bmspreprod",
  "aws_user_files_s3_bucket_region": "eu-west-2"
};

export default awsmobile;
